module.exports = __webpack_public_path__ + "media/images/logo-weo-bd926bf0f9070775e5bde35c1c49d0a0.png";